$(function () {
  if ($('.single')[0]) {
    const $scrollSection = $('.single__hero .container');
    const $imageElement = $('.single__p-image');

    // Set the initial offset dynamically based on viewport height (vh)
    const sectionHeight = $scrollSection.outerHeight();
    const upwardDistance = sectionHeight; // Distance to move upward

    // Calculate the initial top based on viewport height (vh)
    const viewportHeight = $(window).height();
    let initialTopProportion = 65 / 100;
    let initialTop = viewportHeight * initialTopProportion;

    // Speed multiplier for faster movement
    let speedMultiplier = 1; // Adjust this value for faster or slower speeds

    // Check if the screen width is 767px or less
    if ($(window).width() <= 767) {
      initialTopProportion = 75 / 100; // Adjusted proportion for small screens
      speedMultiplier = 1.5; // Adjusted speed multiplier for small screens
    }

    $imageElement.css('top', initialTop + 'px');

    $(window).on('scroll', function () {
      // Get the scroll position
      const scrollTop = $(window).scrollTop();

      // Reset to initial top if scroll is at the very top
      if (scrollTop === 0) {
        $imageElement.css('top', initialTop + 'px');
        return;
      }

      // Calculate the scroll position relative to the section
      const sectionTop = $scrollSection.offset().top;
      const sectionScroll = scrollTop - sectionTop;

      // Check if the scroll is within the section's bounds
      if (sectionScroll >= 0 && sectionScroll <= sectionHeight) {
        // Calculate the upward movement with speed adjustment
        const newTop = initialTop - (sectionScroll / sectionHeight) * upwardDistance * speedMultiplier;
        $imageElement.css('top', newTop + 'px');
      }
    });
  }
});
